// Re-exports the shared introduction page.
export { default } from '../../shared/components/IntroductionPage';
